(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-rbs-drip-product]').forEach(root => {
      if (root.dataset.rbsDripInitialized) return;
      root.dataset.rbsDripInitialized = 'true';
      const variant = root.querySelector('[data-rbs-drip-variant]');
      const quantity = root.querySelector('[data-rbs-drip-quantity]');
      if (!quantity) return;
      const normalizeQuantity = () => {
        const minimum = Math.max(1, Number(quantity.min) || 1);
        const increment = Math.max(1, Number(quantity.step) || 1);
        const entered = Number(quantity.value);
        let value = Number.isFinite(entered) ? Math.max(minimum, entered) : minimum;
        value = minimum + Math.floor((value - minimum) / increment) * increment;
        const maximum = Number(quantity.max);
        if (quantity.max && Number.isFinite(maximum) && maximum >= minimum) {
          value = Math.min(value, minimum + Math.floor((maximum - minimum) / increment) * increment);
        }
        quantity.value = String(value);
        return quantity.value;
      };
      const savedQuantity = new URL(window.location.href).searchParams.get('quantity');
      if (savedQuantity !== null) quantity.value = savedQuantity;
      normalizeQuantity();
      quantity.addEventListener('change', normalizeQuantity);
      variant?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        url.searchParams.set('quantity', normalizeQuantity());
        url.searchParams.delete('option_values');
        window.location.assign(url.href);
      });
      root.addEventListener('click', normalizeQuantity, true);
      const buttons = root.querySelectorAll('#gs-builder-btn, #gs-uploader-btn, #gs-sd-uploader-btn');
      buttons.forEach(button => {
        if (button.tagName !== 'BUTTON' && button.tagName !== 'A') {
          button.setAttribute('role', 'button');
          button.tabIndex = 0;
          button.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              button.click();
            }
          });
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
